var App = App || {};

App.ChangePassword = (function ($) {
    "use strict";

    function init() {
       
        $(document).on("input blur", "#change-password-form input", function () {
            this.setCustomValidity("");
            applyValidationMessages($("#change-password-form"));
        });


        $(document).on("submit", "#change-password-form", function (e) {
            e.preventDefault();

            const $form = $(this);
            const $summary = $form.find(".form-validation-message").empty();
            const $submitBtn = $form.find('button[type="submit"]');

            
            $form.find("input").each((_, el) => el.setCustomValidity(""));
            $form.removeClass("was-validated");
            $form.find(".field-validation-error").text("");

            const formData = {
                CurrentPassword: $("#current-password").val(),
                NewPassword: $("#new-password").val(),
                ConfirmPassword: $("#confirm-password").val()
            };

           
            if (!formData.CurrentPassword || !formData.NewPassword || !formData.ConfirmPassword) {
                $form.find(":invalid").each(function () {
                    this.setCustomValidity("This field is required.");
                });
            }

           
            if (formData.NewPassword && formData.ConfirmPassword && formData.NewPassword !== formData.ConfirmPassword) {
                $("#confirm-password")[0].setCustomValidity("Passwords do not match.");
            }

            if (formData.CurrentPassword && formData.NewPassword && formData.CurrentPassword === formData.NewPassword) {
                const errorMsg = "New password cannot be the same as the current password.";
                $("#new-password")[0].setCustomValidity(errorMsg);
            }

            if ($form[0].checkValidity()) {
                App.Spinner.startSpinner($submitBtn, "Processing");

                $.ajax({
                    type: "POST",
                    url: "/api/change_password",
                    data: JSON.stringify(formData),
                    contentType: "application/json; charset=utf-8"
                })
                    .done(function (response) {
                        if (!response || !response.success) {
                            const message = response?.message || "Unable to process request. Try again later.";
                            $summary.text(message).removeClass("d-none");
                           
                            applyValidationMessages($form);
                            $form.addClass("was-validated");
                        } else {
                            $summary.text(response.message || "Your password has been changed successfully.")
                                .removeClass("d-none");
                           
                            $form[0].reset();
                            $form.find(".field-validation-error").text("");
                            $form.removeClass("was-validated");
                        }
                    })
                    .fail(function () {
                        $summary.text("Unable to process request. Try again later.").removeClass("d-none");
                        $form.addClass("was-validated");
                    })
                    .always(function () {
                        App.Spinner.stopSpinner($submitBtn);
                       
                    });

            } else {
               
                applyValidationMessages($form);
                $form.addClass("was-validated");
            }
        });
    }

  
   
    function applyValidationMessages($form) {
       
        $form.find("input").each(function () {
            const $input = $(this);
            let msg = "";

            if (this.validity.valueMissing) {
                msg = $input.data("val-required") || "A value is required.";
            }
          
            else if (this.validity.tooShort) {
                if ($input.is(":focus") || this.value.length > 0) {
                    msg = "";
                } else {
                   
                    msg = "";
                }
            }
            else if (this.validity.typeMismatch) {
                msg = $input.data("val-type") || "Incorrect format.";
            }
            else if (!this.checkValidity()) {
                msg = this.validationMessage || "";
            }

            $input.siblings(".field-validation-error").text(msg);
        });
    }


    return { init: init };
})(jQuery);

$(function () {
    App.ChangePassword.init();
});
